(()=>{
'use strict';
if(window.AWTechnicalIntelligenceP27?.version)return;
const VERSION='2.7.12';
const norm=v=>String(v??'').trim();
const fold=v=>norm(v).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[_/]+/g,' ').replace(/[^a-z0-9:+.<>=%-]+/g,' ').replace(/\s+/g,' ').trim();
const slug=v=>fold(v).replace(/\s+/g,'_');
const KEY_ALIASES={
  poids:'weight_g',weight:'weight_g',
  hauteur:'height_mm',height:'height_mm',largeur:'width_mm',width:'width_mm',
  longueur_totale:'length_mm',longueur:'length_mm',
  longueur_canon_interne:'barrel_mm',longueur_canon:'barrel_mm',canon_interne_longueur:'barrel_mm',
  energie:'power_j',puissance:'power_j',
  velocite:'velocity',vitesse:'velocity',fps:'velocity',
  propulsion:'propulsion',alimentation:'propulsion',alimentation_gaz:'gas',
  batterie:'battery',batterie_recommandee:'battery',connecteur_batterie:'connector',connectique:'connector',connecteur:'connector',
  standard_chargeur:'magazine_standard',capacite_chargeur:'magazine_capacity',type_chargeur:'magazine_type',
  filetage_canon:'thread',filetage_sortie:'thread',filetage:'thread',
  interfaces_montage:'mounting',interface_montage:'mounting',rail_accessoire:'mounting',rail:'mounting',interface_optique:'optic_mount',
  hop_up:'hopup',hopup:'hopup',
  etu:'electronics',mosfet:'electronics',mosfet_etu:'electronics',electronique_etu:'electronics',electronique:'electronics',ecu:'electronics',
  gearbox:'gearbox',version_gearbox:'gearbox',architecture_gearbox:'gearbox',
  moteur:'motor',materiaux:'material',matiere:'material',construction:'material',
  modes_tir:'fire_modes',blowback:'blowback',calibre:'calibre',
  detection_chargeur_vide:'empty_mag_detection',changement_rapide_ressort:'quick_change_spring',
  fcu:'electronics',rail_principal:'mounting',pression_service:'operating_pressure',pression_entree:'operating_pressure',
  moteur_hpa:'hpa_engine',standard_interne:'internal_standard',mecanisme_rearmement:'action_system'
};
const LABELS={
  power_j:'Puissance',velocity:'Vélocité',barrel_mm:'Canon interne',weight_g:'Poids',length_mm:'Longueur',height_mm:'Hauteur',width_mm:'Largeur',
  connector:'Connecteur',battery:'Batterie',gas:'Gaz / alimentation',magazine_standard:'Standard chargeur',
  magazine_capacity:'Capacité chargeur',magazine_type:'Type chargeur',thread:'Filetage',mounting:'Interfaces',
  optic_mount:'Interface optique',hopup:'Hop-Up',electronics:'Électronique / ETU',gearbox:'Gearbox',
  motor:'Moteur',material:'Construction',fire_modes:'Modes de tir',blowback:'Blowback',calibre:'Calibre',propulsion:'Propulsion',
  empty_mag_detection:'Détection chargeur vide',quick_change_spring:'Changement rapide du ressort',
  operating_pressure:'Pression de service',hpa_engine:'Moteur HPA',internal_standard:'Standard interne',action_system:'Mécanisme / réarmement'
};
const SINGULAR=new Set(['weight_g','length_mm','height_mm','width_mm','barrel_mm','power_j','connector','hopup','gearbox','motor','calibre','empty_mag_detection','quick_change_spring']);
const NUMERIC_METRICS=new Set(['weight_g','length_mm','height_mm','width_mm','barrel_mm','power_j','velocity','magazine_capacity']);
const normalizeKey=k=>KEY_ALIASES[slug(k)]||slug(k);
const statusKey=s=>slug(s);
const decisionGrade=f=>statusKey(f.status)==='verifie'&&Number(f.score||0)>=90;
const documented=f=>['verifie','documente','documente_aw'].includes(statusKey(f.status))&&Number(f.score||0)>=80;
const exactScalar=v=>{const t=norm(v);return !!t&&!/[–—/±<>]|\s(?:a|à|to)\s/i.test(t)};
const numberOf=v=>{const m=norm(v).replace(',','.').match(/-?\d+(?:\.\d+)?/);return m?Number(m[0]):null};
const metric=(f,key)=>{
  if(!NUMERIC_METRICS.has(key)||!decisionGrade(f)||!exactScalar(f.value))return null;
  let n=numberOf(f.value);if(!Number.isFinite(n))return null;
  const u=fold(f.unit);
  if(key==='weight_g'){if(u.includes('kg'))n*=1000;}
  if(key==='length_mm'||key==='height_mm'||key==='width_mm'||key==='barrel_mm'){if(u==='cm')n*=10;else if(u==='m')n*=1000;}
  if(key==='power_j'&&!u.includes('j')&&u!=='')return null;
  return n;
};
function canonicalSingularValue(key,value){
  const t=fold(value);
  if(key==='connector'){
    if(/(?:t[ -]?dean|deans?|t[ -]?plug)/.test(t))return't-dean';
    if(/mini[ -]?tamiya/.test(t))return'mini-tamiya';
    if(/tamiya/.test(t))return'tamiya';
  }
  if(key==='gearbox'){
    const m=t.match(/(?:version\s*)?v?\s*([23678])/);
    if(m)return'v'+m[1];
  }
  if(key==='calibre'){
    const n=numberOf(value);if(Number.isFinite(n))return String(Math.round(n*100)/100);
  }
  return t;
}
function normalizeFact(raw={}){
  const f={
    source:norm(raw.source),category:norm(raw.category),key:normalizeKey(raw.key),
    rawKey:norm(raw.key),value:norm(raw.value),unit:norm(raw.unit),status:norm(raw.status),
    score:Number(raw.score||0),date:norm(raw.date),proof:norm(raw.proof),sourceUrl:norm(raw.sourceUrl),condition:norm(raw.condition)
  };
  f.grade=decisionGrade(f)?'verified':(documented(f)?'documented':'unsupported');
  f.decisionGrade=f.grade==='verified';
  return f;
}
function normalizeFacts(facts=[]){
  const best=new Map();
  for(const raw of Array.isArray(facts)?facts:[]){
    const f=normalizeFact(raw);
    if(!f.key||!f.value||!documented(f))continue;
    const k=[f.key,fold(f.value),fold(f.unit)].join('|');
    const prev=best.get(k);
    if(!prev||Number(f.score)>Number(prev.score)||(f.decisionGrade&&!prev.decisionGrade))best.set(k,f);
  }
  return [...best.values()];
}
function buildProfile(facts=[]){
  const list=normalizeFacts(facts),byKey=new Map(),metrics={},tokens=new Set(),conflicts=[];
  for(const f of list){
    if(!byKey.has(f.key))byKey.set(f.key,[]);
    byKey.get(f.key).push(f);
    [f.key,f.rawKey,f.category,f.value].forEach(v=>fold(v).split(' ').filter(Boolean).forEach(t=>tokens.add(t)));
    const m=metric(f,f.key);if(m!==null&&(metrics[f.key]===undefined||f.score>(metrics[f.key]?.score||0)))metrics[f.key]={value:m,unit:f.unit,score:f.score};
  }
  for(const [key,rows] of byKey){
    if(!SINGULAR.has(key))continue;
    const conflictRows=rows.filter(r=>r.decisionGrade&&exactScalar(r.value));
    const values=[...new Set(conflictRows.map(r=>canonicalSingularValue(key,r.value)+'|'+fold(r.unit)))];
    if(values.length>1)conflicts.push({key,label:LABELS[key]||key,values:conflictRows.map(r=>({value:r.value,unit:r.unit,score:r.score}))});
  }
  return {version:VERSION,facts:list,byKey,metrics,tokens,conflicts,verified:list.filter(f=>f.decisionGrade),documented:list.filter(f=>!f.decisionGrade)};
}
const firstValue=(p,key)=>p?.byKey?.get(key)?.[0]||null;
const strongestFact=(p,key)=>(p?.byKey?.get(key)||[]).slice().sort((a,b)=>(Number(b.decisionGrade)-Number(a.decisionGrade))||(Number(b.score||0)-Number(a.score||0))||String(b.date||'').localeCompare(String(a.date||'')))[0]||null;
function display(p,key){
  const m=p?.metrics?.[key];
  if(m){
    if(key==='weight_g')return Math.round(m.value)+' g';
    if(key==='length_mm'||key==='height_mm'||key==='width_mm'||key==='barrel_mm')return Math.round(m.value)+' mm';
    if(key==='power_j')return String(Math.round(m.value*100)/100).replace('.',',')+' J';
    return String(m.value);
  }
  const rows=p?.byKey?.get(key)||[];
  if(SINGULAR.has(key)&&rows.length){
    const groups=new Map;
    for(const r of rows){
      const c=canonicalSingularValue(key,r.value);
      if(!groups.has(c))groups.set(c,[]);
      groups.get(c).push(r);
    }
    if(groups.size===1){
      const best=[...groups.values()][0].slice().sort((a,b)=>(Number(b.decisionGrade)-Number(a.decisionGrade))||(b.score-a.score)||(a.value.length-b.value.length))[0];
      return best.value+(best.unit?' '+best.unit:'');
    }
  }
  return [...new Set(rows.map(r=>r.value+(r.unit?' '+r.unit:'')))].join(' · ');
}
const COMPARE_KEYS=['power_j','velocity','barrel_mm','weight_g','length_mm','height_mm','width_mm','connector','battery','gas','operating_pressure','magazine_standard','magazine_capacity','thread','mounting','optic_mount','hopup','electronics','gearbox','motor','hpa_engine','internal_standard','action_system','fire_modes','blowback','material','calibre','empty_mag_detection','quick_change_spring'];
function compare(profiles=[]){
  return COMPARE_KEYS.map(key=>{
    const values=profiles.map(p=>display(p,key));
    const present=values.some(Boolean);
    const different=new Set(values.map(v=>fold(v))).size>1;
    return {key,label:LABELS[key]||key,values,present,different};
  }).filter(r=>r.present);
}
function parseQuery(query=''){
  const q=fold(query),constraints=[],patterns=[
    ['weight_g',/(?:poids|weight)\s*(?:<=|<|moins de|max(?:imum)?)\s*(\d+(?:[.,]\d+)?)\s*(kg|g)?/],
    ['length_mm',/(?:longueur|length)\s*(?:<=|<|moins de|max(?:imum)?)\s*(\d+(?:[.,]\d+)?)\s*(mm|cm|m)?/],
    ['barrel_mm',/(?:canon|barrel)\s*(?:>=|>|plus de|min(?:imum)?)\s*(\d+(?:[.,]\d+)?)\s*(mm|cm|m)?/],
    ['power_j',/(?:puissance|energie|joule|joules)\s*(?:<=|<|moins de|max(?:imum)?)\s*(\d+(?:[.,]\d+)?)\s*j?/]
  ];
  for(const [key,re] of patterns){const m=q.match(re);if(m){let n=Number(String(m[1]).replace(',','.'));const u=m[2]||'';if(key==='weight_g'&&u==='kg')n*=1000;if((key==='length_mm'||key==='barrel_mm')&&u==='cm')n*=10;if((key==='length_mm'||key==='barrel_mm')&&u==='m')n*=1000;constraints.push({key,op:key==='barrel_mm'?'>=':'<=',value:n});}}
  const text=q.replace(/[<>=]/g,' ').split(' ').filter(t=>t.length>1&&!/^\d/.test(t)&&!['poids','weight','longueur','length','canon','barrel','puissance','energie','joule','joules','moins','plus','maximum','minimum','max','min','de','mm','cm','kg'].includes(t));
  return {raw:query,constraints,text};
}
function matches(profile,query){
  const parsed=typeof query==='string'?parseQuery(query):query;
  const reasons=[];
  for(const c of parsed.constraints||[]){
    const m=profile.metrics[c.key];
    if(!m)return {match:false,reasons:['missing:'+c.key],parsed};
    if(c.op==='<='&&!(m.value<=c.value))return {match:false,reasons:['over:'+c.key],parsed};
    if(c.op==='>='&&!(m.value>=c.value))return {match:false,reasons:['under:'+c.key],parsed};
    reasons.push('metric:'+c.key);
  }
  const hay=[...profile.tokens].join(' ');
  for(const t of parsed.text||[]){if(!hay.includes(t))return {match:false,reasons:['token:'+t],parsed};reasons.push('token:'+t);}
  return {match:true,reasons,parsed};
}
function diagnostics(profile){
  const missing=['propulsion','hopup'].filter(k=>!display(profile,k));
  return {conflicts:profile.conflicts,missingCore:missing,decisionGradeFacts:profile.verified.length,documentedFacts:profile.documented.length};
}
function seoTerms(profile,limit=24){
  const out=[];for(const f of profile.verified){for(const v of [f.value,f.category]){const x=norm(v);if(x&&!out.includes(x))out.push(x);if(out.length>=limit)return out;}}return out;
}
function atelierChecklist(profile){
  return ['propulsion','connector','battery','gas','operating_pressure','magazine_standard','thread','mounting','hopup','electronics','gearbox','motor','hpa_engine','internal_standard','action_system','barrel_mm'].map(key=>({key,label:LABELS[key]||key,value:display(profile,key),verified:Boolean((profile.byKey.get(key)||[]).find(f=>f.decisionGrade))})).filter(x=>x.value);
}

const INTERFACE_KEYS=['connector','thread','optic_mount','calibre'];
function compatibilitySignals(a,b){
  const signals=[];
  for(const key of INTERFACE_KEYS){
    const av=(a?.byKey?.get(key)||[]).filter(f=>f.decisionGrade&&exactScalar(f.value)).map(f=>canonicalSingularValue(key,f.value));
    const bv=(b?.byKey?.get(key)||[]).filter(f=>f.decisionGrade&&exactScalar(f.value)).map(f=>canonicalSingularValue(key,f.value));
    if(!av.length||!bv.length)continue;
    const shared=av.some(v=>bv.includes(v));
    signals.push({key,label:LABELS[key]||key,state:shared?'shared_standard':'mismatch_signal',left:[...new Set(av)],right:[...new Set(bv)],proof:'verified>=90',finalCompatibility:false});
  }
  return signals;
}
function guideContext(profile){
  return {
    version:VERSION,
    verifiedFacts:profile.verified.map(f=>({key:f.key,value:f.value,unit:f.unit,category:f.category,score:f.score,date:f.date,proof:f.proof,sourceUrl:f.sourceUrl,condition:f.condition})),
    documentedFacts:profile.documented.map(f=>({key:f.key,value:f.value,unit:f.unit,category:f.category,score:f.score,date:f.date,proof:f.proof,sourceUrl:f.sourceUrl,condition:f.condition})),
    topics:seoTerms(profile,32),
    diagnostics:diagnostics(profile)
  };
}
function customerContext(profile){
  return {
    version:VERSION,
    facts:profile.verified.map(f=>({label:LABELS[f.key]||f.rawKey||f.key,value:f.value,unit:f.unit,score:f.score,date:f.date,proof:f.proof,sourceUrl:f.sourceUrl,condition:f.condition})),
    informational:profile.documented.map(f=>({label:LABELS[f.key]||f.rawKey||f.key,value:f.value,unit:f.unit,score:f.score,date:f.date,proof:f.proof,sourceUrl:f.sourceUrl,condition:f.condition})),
    unknownPolicy:'missing stays unknown',
    compatibilityPolicy:'technical facts do not create a compatibility relation'
  };
}

function diagnosticContext(profile,symptom=''){
  const q=fold(symptom),checks=[];
  const add=(key,reason,priority=50)=>{
    const value=display(profile,key);
    checks.push({key,label:LABELS[key]||key,value:value||'',verified:Boolean((profile.byKey.get(key)||[]).find(f=>f.decisionGrade)),known:Boolean(value),reason,priority});
  };
  if(/(?:portee|portée|precision|précision|dispersion|bille|trajectoire|hop)/.test(q)){
    add('hopup','Contrôler le système Hop-Up documenté',100);
    add('barrel_mm','Contrôler la longueur de canon interne documentée',90);
    add('calibre','Contrôler le calibre documenté',80);
  }
  if(/(?:cadence|reactivite|réactivité|semi|rafale|trigger|detente|détente|etu|mosfet)/.test(q)){
    add('electronics','Contrôler l’électronique / ETU documentée',100);
    add('motor','Contrôler le moteur documenté',90);
    add('gearbox','Contrôler l’architecture Gearbox documentée',80);
    add('connector','Contrôler le connecteur d’alimentation',70);
  }
  if(/(?:alimentation|batterie|battery|coupure|alim|deans|tamiya)/.test(q)){
    add('battery','Contrôler la batterie documentée',100);
    add('connector','Contrôler le connecteur documenté',95);
    add('electronics','Contrôler l’électronique protégée / ETU',80);
  }
  if(/(?:gaz|co2|pression|fuite|degaz|dégaz|gbb|gbbr|hpa)/.test(q)){
    add('propulsion','Contrôler le mode de propulsion',100);
    add('gas','Contrôler le gaz / alimentation documenté',95);
    add('operating_pressure','Contrôler la pression de service documentée',92);
    add('hpa_engine','Contrôler le moteur HPA documenté',88);
    add('electronics','Contrôler la FCU / électronique documentée',82);
  }
  if(/(?:chargeur|magazine|alimentation billes|feed|feeding)/.test(q)){
    add('magazine_standard','Contrôler le standard chargeur',100);
    add('magazine_type','Contrôler le type de chargeur',90);
    add('magazine_capacity','Contrôler la capacité documentée',70);
  }
  if(/(?:silencieux|traceur|filetage|thread)/.test(q))add('thread','Contrôler le filetage canon documenté',100);
  if(/(?:optique|red dot|lunette|viseur|rail|montage)/.test(q)){
    add('optic_mount','Contrôler l’interface optique',100);
    add('mounting','Contrôler les interfaces / rails documentés',90);
  }
  if(!checks.length){
    ['propulsion','hopup','electronics','gearbox','connector','thread'].forEach((k,i)=>add(k,'Contexte technique général',60-i*5));
  }
  const dedup=[...new Map(checks.map(x=>[x.key,x])).values()].sort((a,b)=>b.priority-a.priority);
  return {
    version:VERSION,
    symptom:norm(symptom),
    checks:dedup,
    unknown:dedup.filter(x=>!x.known).map(x=>x.key),
    conflicts:profile.conflicts,
    policy:'diagnostic-support-only; facts do not prove root cause; missing stays unknown'
  };
}
function recommendationConstraints(profile){
  const keys=['connector','thread','optic_mount','mounting','calibre','propulsion','magazine_standard','battery','internal_standard'];
  const hard=[],informational=[];
  for(const key of keys){
    const f=strongestFact(profile,key),value=display(profile,key);
    if(!f||!value)continue;
    const row={key,label:LABELS[key]||key,value,score:Number(f.score||0),date:f.date||'',proof:f.proof||'',sourceUrl:f.sourceUrl||'',condition:f.condition||''};
    if(f.decisionGrade)hard.push(row);else informational.push(row);
  }
  return {
    version:VERSION,
    hard,
    informational,
    conflicts:profile.conflicts.map(x=>x.key),
    exactCompatibilityGateRequired:true,
    policy:'verified facts may constrain candidate retrieval; documented facts are informational only; exact Compatibility remains authoritative'
  };
}
function recommendationContext(profile){
  const d=diagnostics(profile),out=[],constraints=recommendationConstraints(profile);
  const push=(category,reason,score)=>out.push({category,reason,score});
  if(!display(profile,'hopup'))push('technical_review','Hop-Up non documenté',90);
  if(!display(profile,'barrel_mm'))push('technical_review','Canon interne non documenté',85);
  if(display(profile,'optic_mount')&&!display(profile,'mounting'))push('mounting_review','Interface optique connue mais rails généraux incomplets',70);
  if(display(profile,'electronics')&&!display(profile,'connector'))push('power_review','Électronique documentée mais connecteur inconnu',75);
  if(d.conflicts.length)push('data_review','Faits techniques décisionnels contradictoires',100);
  return {version:VERSION,signals:out.sort((a,b)=>b.score-a.score),constraints,policy:'signals and retrieval constraints only; never creates product compatibility'};
}
function atelierBrief(profile){
  return {
    version:VERSION,
    checklist:atelierChecklist(profile),
    conflicts:profile.conflicts,
    missingCore:diagnostics(profile).missingCore,
    verifiedCount:profile.verified.length,
    documentedCount:profile.documented.length,
    caution:'Le brief prépare le diagnostic Atelier mais ne remplace ni mesure physique ni intervention certifiée.'
  };
}
const QUERY_STOP=new Set(['quel','quelle','quels','quelles','avec','pour','cette','cette','replique','réplique','airsoft','est','sont','utilise','utilisee','utilisée','documente','documenté','donnee','donnée','technique','techniques','combien','avoir']);
function relevantFacts(profile,question='',limit=10){
  const tokens=fold(question).split(' ').filter(t=>t.length>2&&!QUERY_STOP.has(t));
  if(!tokens.length)return[];
  const rows=[];
  for(const f of profile?.facts||[]){
    const label=LABELS[f.key]||f.rawKey||f.key;
    const keyText=fold([f.key,f.rawKey,label,f.category].join(' '));
    const valueText=fold(f.value);
    let score=0;
    for(const t of tokens){
      if(keyText.includes(t))score+=4;
      else if(valueText.includes(t))score+=1;
    }
    if(score>0)rows.push({f,score});
  }
  rows.sort((a,b)=>b.score-a.score||(Number(b.f.decisionGrade)-Number(a.f.decisionGrade))||(b.f.score-a.f.score));
  const out=[],seen=new Set;
  for(const row of rows){
    if(seen.has(row.f.key))continue;
    seen.add(row.f.key);out.push(row.f);
    if(out.length>=limit)break;
  }
  return out;
}
function answerContext(profile,question=''){
  const q=fold(question),keys=[];
  const wants=(re,list)=>{if(re.test(q))list.forEach(k=>keys.push(k));};
  wants(/(?:poids|weight)/,['weight_g']);
  wants(/(?:hauteur|height)/,['height_mm']);
  wants(/(?:largeur|width)/,['width_mm']);
  wants(/(?:longueur|length|taille)/,['length_mm']);
  wants(/(?:canon|barrel)/,['barrel_mm','calibre','thread']);
  wants(/(?:puissance|joule|energie|énergie|fps|vitesse|velocite|vélocité)/,['power_j','velocity']);
  wants(/(?:batterie|battery)/,['battery']);
  wants(/(?:connecteur|deans|tamiya|t-plug)/,['connector']);
  const emptyMagIntent=/(?:chargeur vide|empty mag|detection chargeur|détection chargeur)/.test(q);
  if(emptyMagIntent)keys.push('empty_mag_detection');
  if(!emptyMagIntent)wants(/(?:chargeur|magazine)/,['magazine_standard','magazine_type','magazine_capacity']);
  wants(/(?:hop|precision|précision)/,['hopup','barrel_mm']);
  wants(/(?:etu|mosfet|electronique|électronique|ecu|fcu)/,['electronics']);
  wants(/(?:pression|psi)/,['operating_pressure']);
  wants(/(?:moteur hpa|hpa engine|inferno)/,['hpa_engine']);
  wants(/(?:standard interne|vsr-10|vsr10)/,['internal_standard']);
  wants(/(?:rearmement|réarmement|bolt action)/,['action_system']);
  wants(/(?:gearbox|moteur|motor)/,['gearbox','motor']);
  wants(/(?:ressort|spring|quick change|changement rapide)/,['quick_change_spring']);
  wants(/(?:filetage|silencieux|traceur)/,['thread']);
  wants(/(?:rail|optique|montage)/,['mounting','optic_mount']);
  wants(/(?:propulsion)/,['propulsion']);
  wants(/(?:gaz|co2|hpa)/,['propulsion','gas']);
  if(!keys.length){
    const generic=relevantFacts(profile,question,10);
    generic.forEach(f=>keys.push(f.key));
  }
  const selected=[...new Set(keys.length?keys:COMPARE_KEYS.slice(0,10))];
  return {
    version:VERSION,
    question:norm(question),
    facts:selected.map(key=>{const f=strongestFact(profile,key),value=display(profile,key);return value?{key,label:LABELS[key]||f?.rawKey||key,value,verified:Boolean(f?.decisionGrade),score:Number(f?.score||0),date:f?.date||'',proof:f?.proof||'',sourceUrl:f?.sourceUrl||'',condition:f?.condition||''}:null}).filter(Boolean),
    unknown:selected.filter(key=>!display(profile,key)),
    policy:'answer only from supplied facts; missing stays unknown; technical facts do not create compatibility'
  };
}
window.AWTechnicalIntelligenceP27={version:VERSION,normalizeKey,canonicalSingularValue,normalizeFact,normalizeFacts,buildProfile,strongestFact,relevantFacts,display,compare,parseQuery,matches,diagnostics,seoTerms,atelierChecklist,compatibilitySignals,guideContext,customerContext,diagnosticContext,recommendationConstraints,recommendationContext,atelierBrief,answerContext,policy:'verified>=90 decision-grade; documented>=80 informational; never invent missing facts; exact-model scope only when deterministic'};
window.dispatchEvent(new CustomEvent('aw:p27:technical-intelligence-ready',{detail:{version:VERSION}}));
})();